import "styled-components";

const winterTheme = {
  layout: {
    background: `   
    url("${process.env.PUBLIC_URL}/assets/images/background/snowflakes.png") no-repeat center center,
    radial-gradient(circle, #649dad, #1E3A47)`,
  },
  header: {
    fontColor: "#ebe3d8",
    // backgroundColor: "#305e70",
    background: `linear-gradient(to right, transparent, rgba(33,74,89, 0.9), transparent)`,
  },
  footer: {
    fontColor: "#E0E0E0",
  },
  switcher: {
    // background: `linear-gradient(to right, transparent, #3D6B77, transparent)`,
    background: `linear-gradient(to right, transparent, rgba(255, 255, 255, 0.3), transparent)`,

    headerBackgroundColor: "#305e70",
    bodyBackgroundColor: "#649dad",
    hoverColor: "#e1aca9",
    fontColor: "#ebe3d8",
    buttonFontColor: "#decebe",
  },
  calendar: {
    backgroundColors: {
      emptyCell: "#decebe",
      mainCell: "#fbe9db",
      dayOfWeekCell: "#fbe9db",
    },
    fontColors: {
      main: "#9f8a6f",
      empty: "#c0bdb9",
      day: "#6f604d",
      sunday: "#cf7b76",
    },
  },
};

export default winterTheme;
